import { createContext, useContext, type FunctionComponent, type ReactNode } from "react";

import { type useRiskAssessmentFieldActions } from "./useRiskAssessmentFieldActions";

export type RiskAssessmentFieldActionsValue = ReturnType<typeof useRiskAssessmentFieldActions>;

const RiskAssessmentFieldActionsContext = createContext<RiskAssessmentFieldActionsValue | undefined>(undefined);

export interface RiskAssessmentFieldActionsProviderProps {
  value: RiskAssessmentFieldActionsValue;
  children: ReactNode;
}

export const RiskAssessmentFieldActionsProvider: FunctionComponent<RiskAssessmentFieldActionsProviderProps> = ({ value, children }) => (
  <RiskAssessmentFieldActionsContext.Provider value={value}>{children}</RiskAssessmentFieldActionsContext.Provider>
);

export function useRiskAssessmentFieldActionsContext(): RiskAssessmentFieldActionsValue {
  const context = useContext(RiskAssessmentFieldActionsContext);
  if (context === undefined) {
    throw new Error("useRiskAssessmentFieldActionsContext must be used within a RiskAssessmentFieldActionsProvider");
  }
  return context;
}
